// extracted by mini-css-extract-plugin
export default {"marginTop":"section-module__marginTop","section":"section-module__section","container":"section-module__container"};